export function stripUIState(nodes = [], edges = []) {
  // Allow-list of node and edge keys we want to preserve
  // Everything else (style, selected, dragging, etc.) is dropped.
  const allowedNodeKeys = [
    'id',
    'type',
    'position',
    'data',
    'width', // actual rendered size sometimes needed for layout restore
    'height',
    'collectsInput' // Core behavioral property for auto-advance
  ];
  const allowedEdgeKeys = [
    'id',
    'source',
    'target',
    'data',
    'type'
  ];

  const cleanNodes = nodes.map((n) => {
    console.log(`🔍 PERSIST: Processing node ${n.id}, collectsInput at root: ${n.collectsInput}, in data: ${n.data?.collectsInput}`);
    
    const cleaned = {};
    allowedNodeKeys.forEach((key) => {
      if (n[key] !== undefined) cleaned[key] = n[key];
    });
    
    console.log(`🔍 PERSIST: After cleaning node ${n.id}, collectsInput preserved: ${cleaned.collectsInput}, in data: ${cleaned.data?.collectsInput}`);
    
    // Deep-clone data to avoid mutating caller
    if (cleaned.data) cleaned.data = JSON.parse(JSON.stringify(cleaned.data));
    return cleaned;
  });

  // Build node id set to purge edges targeting deleted/unknown nodes
  const nodeIdSet = new Set(cleanNodes.map(n => n.id));
  const cleanEdges = edges
    .map((e) => {
      const cleaned = {};
      allowedEdgeKeys.forEach((key) => {
        if (e[key] !== undefined) cleaned[key] = e[key];
      });
      if (cleaned.data) cleaned.data = JSON.parse(JSON.stringify(cleaned.data));

      // Synthesise condition if only value provided
      if (cleaned.data && !cleaned.data.condition && cleaned.data.expectedValue) {
        // Look up source node variable (if available)
        const srcNode = nodes.find((n) => n.id === e.source);
        const varName = srcNode?.data?.variable || srcNode?.id;
        cleaned.data.condition = `${varName} == "${cleaned.data.expectedValue}"`;
      }
      return cleaned;
    })
    .filter((e) => nodeIdSet.has(e.source) && nodeIdSet.has(e.target));

  return { nodes: cleanNodes, edges: cleanEdges };
}

export function validateSurveyRules(nodes = [], edges = []) {
  // New policy: do not block. Only return empty errors and warnings.
  return { errors: [], warnings: [] };
} 